import { UpdateLocaleValueEnum } from "../api";

export const getLanguageCode = (lang: string): UpdateLocaleValueEnum => {
  switch (lang) {
    case "sk":
      return UpdateLocaleValueEnum.Sk;
    case "en":
      return UpdateLocaleValueEnum.En;
    case "de":
      return UpdateLocaleValueEnum.De;
    case "hu":
      return UpdateLocaleValueEnum.Hu;
    case "pl":
      return UpdateLocaleValueEnum.Pl;
    default:
      return UpdateLocaleValueEnum.Sk;
  }
};
